<template>
    <div class="chart-container region-compare">
        <div class="primary-value">
            <div class="label">
                <div class="inline-block">
                    Proportion of people who {{ model.label }}
                </div>
            </div>
        </div>
        <template v-if="model.value">
            <div class="row-container">
                <div class="region-label">
                    {{ model.valueRecord.geographyName }}
                </div>
                <dynamic-resize-container
                    class="dot-plot"
                >
                    <template
                        #default="{width}"
                    >
                        <dot-plot
                            v-if="width > 0"
                            :width="width"
                            :height="12"
                            :value="model.value"
                            :compare-value="null"
                            :domain="model.domain"
                        />
                    </template>
                </dynamic-resize-container>
                <div class="percent-label">
                    {{ model.formatWithUnits(model.value) }}
                </div>
            </div>
            <div class="row-container province-row">
                <div class="region-label">
                    {{ model.comparisonRecord.geographyName }}
                </div>
                <dynamic-resize-container
                    class="dot-plot"
                >
                    <template
                        #default="{width}"
                    >
                        <dot-plot
                            v-if="width > 0"
                            :width="width"
                            :height="12"
                            :value="model.comparisonValue"
                            :compare-value="null"
                            :domain="model.domain"
                        />
                    </template>
                </dynamic-resize-container>
                <div class="percent-label">
                    {{ model.formatWithUnits(model.comparisonValue) }}
                </div>
            </div>
            <div class="row-container best-row">
                <div class="region-label">
                    <span>Best {{ model.bestRecord && model.bestRecord.urbanRuralClass }}</span>
                    <i>{{ model.bestRecord && model.bestRecord.geographyName }} LGA</i>
                </div>
                <dynamic-resize-container
                    class="dot-plot"
                >
                    <template
                        #default="{width}"
                    >
                        <dot-plot
                            v-if="width > 0"
                            :width="width"
                            :height="12"
                            :value="model.bestValue"
                            :compare-value="null"
                            :domain="model.domain"
                        />
                    </template>
                </dynamic-resize-container>
                <div class="percent-label">
                    {{ model.formatWithUnits(model.bestValue) }}
                </div>
            </div>
        </template>
        <template v-else>
            <dynamic-resize-container
                class="dot-plot province-row"
            >
                <template
                    #default="{width}"
                >
                    <dot-plot
                        v-if="width > 0 && model.zoneValue"
                        :width="width"
                        :height="12"
                        :value="model.zoneValue"
                        :compare-value="null"
                        :domain="model.domain"
                    />
                </template>
            </dynamic-resize-container>
            <dynamic-resize-container
                class="dot-plot province-row"
            >
                <template
                    #default="{width}"
                >
                    <dot-plot
                        v-if="width > 0 && model.abValue"
                        :width="width"
                        :height="12"
                        :value="model.abValue"
                        :compare-value="null"
                        :domain="model.domain"
                    />
                </template>
            </dynamic-resize-container>
            <dynamic-resize-container
                class="dot-plot province-row"
            >
                <template
                    #default="{width}"
                >
                    <dot-plot
                        v-if="width > 0 && model.bestValue"
                        :width="width"
                        :height="12"
                        :value="model.bestValue"
                        :compare-value="null"
                        :domain="model.domain"
                    />
                </template>
            </dynamic-resize-container>
        </template>
    </div>
</template>

<script>
import DynamicResizeContainer from '@/components/DynamicResizeContainer.vue';
import DotPlot from '@/components/DotPlot.vue';
import MetricChartModel from '@/model/MetricChartModel';

export default {
    components: {
        DynamicResizeContainer,
        DotPlot
    },
    props: {
        model: {
            type: MetricChartModel,
            required: true
        }
    },
};
</script>

<style src="./common.container.css" scoped></style>
<style scoped>
.primary-value {
    @apply flex flex-row justify-start items-baseline mb-2;
}

.label {
    @apply text-left;
}

.row-container {
    @apply flex flex-row items-center relative w-full py-1;
}

.province-row {
    @apply text-neutral-2;
}

.pdf .region-compare .resize-container {
    min-width: 180px;
    max-width: 180px;
}

.region-label {
    @apply flex flex-col w-2/5 h-full pr-1 leading-none;
}

.best-row > .region-label > span,
.best-row > .dot-plot,
.best-row > .percent-label {
    @apply text-neutral-2;
}

.resize-container {
    @apply w-1/2 h-full px-1;
}

.percent-label {
    @apply h-full px-2 leading-none;
    width: 10%;
}
</style>
